import { createSlice } from '@reduxjs/toolkit'
import name from './name'
import { ENTERPRISE_READER, CLIENT_MANAGER } from '../../util/userGroups'

const initialState = {
  msaTenantConfig: {
    numberOfUsers: 0,
    assessmentExternalId: undefined,
    seatsAvailable: 0,
    benchmarkScores: [],
    usersList: [],
    completedAssessments: [],
    metaSkills: [],
    trialSupported: false,
    isTrial: false
  }
}

// Store
export const msaTenantConfig = createSlice({
  name,
  initialState,
  reducers: {
    getMSATenantConfig: (state, { payload }) => {
      if (!payload) return
      const { numberOfUsers, sk, benchmarkScores, usersList = [], completedAssessments = [], metaSkills, isTrial, trialSupported } = payload
      state.msaTenantConfig.numberOfUsers = numberOfUsers
      state.msaTenantConfig.assessmentExternalId = sk
      state.msaTenantConfig.benchmarkScores = benchmarkScores
      state.msaTenantConfig.usersList = usersList || []
      state.msaTenantConfig.completedAssessments = completedAssessments || []
      state.msaTenantConfig.seatsAvailable = numberOfUsers > usersList.length ? (numberOfUsers - usersList.length) : 0
      state.msaTenantConfig.metaSkills = metaSkills
      state.msaTenantConfig.isTrial = isTrial
      state.msaTenantConfig.trialSupported = trialSupported
    },
    updateMSATenantConfig: (state, { payload: { numberOfUsers, benchmarkScores, isTrial } }) => {
      state.msaTenantConfig.numberOfUsers = numberOfUsers
      state.msaTenantConfig.benchmarkScores = benchmarkScores
      state.msaTenantConfig.seatsAvailable = numberOfUsers - state.msaTenantConfig.usersList.length
      state.msaTenantConfig.isTrial = isTrial
    },
    updateUserOnList: (state, { payload: { updatedFeatures, updatedUser } }) => {
      const rolesAllowedToOccupySeats = [ENTERPRISE_READER, CLIENT_MANAGER]
      if (!rolesAllowedToOccupySeats.includes(updatedUser.role)) return

      const isUserAlreadyOnList = state.msaTenantConfig.usersList.includes(updatedUser.sk)
      const msa = updatedFeatures['msa:access']

      if (isUserAlreadyOnList && msa === true) return

      if (msa === true) {
        state.msaTenantConfig.usersList.push(updatedUser.sk)
        state.msaTenantConfig.seatsAvailable = state.msaTenantConfig.seatsAvailable - 1
      } else {
        state.msaTenantConfig.usersList = state.msaTenantConfig.usersList.filter(user => user !== updatedUser.sk)
        state.msaTenantConfig.seatsAvailable = state.msaTenantConfig.seatsAvailable + 1
      }
    },
    pushUsersToList: (state, { payload }) => {
      for (const user of payload) {
        state.msaTenantConfig.usersList.push(user)
        state.msaTenantConfig.seatsAvailable = state.msaTenantConfig.seatsAvailable - 1
      }
    },
    reset: () => initialState
  }
})

export const {
  getMSATenantConfig,
  updateMSATenantConfig,
  updateUserOnList,
  pushUsersToList,
  reset
} = msaTenantConfig.actions

export default msaTenantConfig.reducer
